import AgTechGrid from '@agtech/web/components/Grids/AgTechGrid';
import AgTechGridLink from '@agtech/web/components/Grids/Controls/AgTechGridLink';
import { AgTechGridProps } from '@agtech/web/components/Grids/Data/AgTechGridProps';
import { SaleDiscount } from '@sales/data/sales/discounts/SaleDiscountData';
import React from 'react'
import SaleDiscountDialog from '../../dialogs/SaleDiscountDialog';
import { SaleDiscountActionButton } from '../buttons/SaleDiscountButtons';
import { AgTechIndex } from '@agtech/core/utilities/AgTechUtilities';
import { useAgTechOptionalQuery } from '@agtech/core/data/queries/AgTechDataQueries';
import { DiscountDataGetAllDiscountsQuery } from '@sales/data/sales/discounts/SaleDiscountDataQueries';

const SaleDiscountViewGrid = (props: {
    discounts?: AgTechIndex<SaleDiscount>,
    gridProps?: (props: AgTechGridProps<SaleDiscount>) => AgTechGridProps<SaleDiscount>
}) => {
    const gridQuery = useAgTechOptionalQuery({
        query: DiscountDataGetAllDiscountsQuery,
        data: props.discounts,
        projection: (index) => {
            return {
                items: Object.values(index)
            };
        }
    });

    return (
        <AgTechGrid
            header={{
                title: `Sale Discounts`,
                content: () => <SaleDiscountDialog.Button />
            }}
            data={{
                itemQuery: gridQuery
            }}
            columns={[
                {
                    header: "Name",
                    classes: 'bg-slate-100 emphasized',
                    size: 2,
                    value: discount => (
                        <AgTechGridLink
                            content={discount.name}
                            onClick={e => e.dialogs.openDialog({
                                dialog: () => <SaleDiscountDialog discount={discount} />
                            })}
                        />
                    ),
                },
                {
                    header: "Amount",
                    value: discount => (discount.isPercentage ? '' : '$') + discount.amount + (discount.isPercentage ? '%' : '')
                },
                {
                    header: "Type",
                    value: discount => discount.isPercentage ? 'Percentage' : 'Amount'
                }
            ]}
            isRowEntityTheSame={(prev, curr) => {
                return prev.name === curr.name &&
                    prev.isPercentage === curr.isPercentage &&
                    prev.amount === curr.amount;
            }}
            noRecordsConfig={{
                message: 'No discounts were found in the system',
                action: {
                    prompt: 'To create one, click the button below',
                    button: () => <SaleDiscountDialog.Button classes='button-highlight' />
                }
            }}
            actions={{
                rendering: c => <SaleDiscountActionButton discount={c} />
            }}
            propModifier={props.gridProps}
        />
    );
}

export default SaleDiscountViewGrid